import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _JobRequisition } from "../../../../../core/services/dataBean/EntityCatalog";
import { useEffect } from "react";
import useModal, { MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { HandlerInfoProcess } from "../../../../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import usePaginator from "../../../../theme/Component/usePaginator";


export const JobRequisition = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_JobRequisition);

    const paginador = usePaginator();

    const modalHistory = useModal("Historial del procedimiento", MODAL_XL)

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {

        }

        instance.getJobRequisitionRender(paginador.page, 15, props).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);

                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;

                    data.AreaEntity = data.IDLnFunctionalID ? `${data.AreaJsonCode} - ${data.AreaName}` : "N/P";

                });

                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Solicitudes");
        });
    };

    const head = [
        { title: 'ID', property: 'IDJobRequisition', visible: true },
        { title: 'Solicitante', property: 'EmployeeFullName', visible: true },
        { title: 'Fecha de Solicitud', property: 'Since', visible: true },
        { title: 'Area', property: 'AreaEntity', visible: true },
        { title: 'Plaza de contratación', property: 'PlazaName', visible: true },
        { title: 'Procedimiento Asociado', property: 'ProcedureAlphaCode', visible: true },
        { title: 'Contrato', property: 'ProcedureAlphaCode', visible: true },
        { title: 'Personal Contratado', property: 'AccountFullName', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ];


    const listaBotones = () => {
        const botones = [
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: bean.IDProcedureIMP, evento: () => { modalHistory.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Lista de Solicitudes Contratación de Vacantes">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureIMP} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}